module.exports = __webpack_public_path__ + "img/file_view_data.4b4fc1c6.png";